var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ListCard',{attrs:{"is-table":"","white":"","no-padding":"","card-list":_vm.auditerList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }